import React from "react";
import { Stepper, Step, StepLabel, withStyles } from "@material-ui/core";
const styles = (theme) => ({
  labelStyle: {
    color: theme.iconColor,
    fontWeight: "600 !important",
    fontSize: theme.headerTextFontSize,
  },
  activeLabelStyle: {
    color: `${theme.HeaderSelectedText} !important`,
    fontWeight: 600,
    fontSize: theme.headerTextFontSize,
  },
  rootstep: {
    backgroundColor: "transparent",
    padding: 0,
    paddingBottom: 12,
    width: "100%",
  },
  stepIconStyle: {
    width: "24px",
    height: "24px",
    fontWeight: 600,
    color: theme.iconColor,
  },
  stepperStyle: {
    display: "flex",
    width: "100%",
    alignItems: "baseline",
  },
});

const ShipmentSelectionStepper = ({ classes, steps, activeStep }) => {
  return (
    <div className={classes.stepperStyle}>
      <Stepper
        alternativeLabel
        nonLinear
        activeStep={activeStep}
        classes={{
          root: classes.rootstep,
        }}
        id="Stepper"
      >
        {steps.map((label) => {
          return (
            <Step key={label}>
              <StepLabel
                completed={false}
                StepIconProps={{
                  classes: { root: classes.stepIconStyle },
                }}
                classes={{
                  label: classes.labelStyle,
                  active: classes.activeLabelStyle,
                  completed: classes.activeLabelStyle,
                }}
              >
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};
export default withStyles(styles)(ShipmentSelectionStepper);
